import React from 'react';
import { heroImage, heroVideo } from '../mock';

export default function Hero() {
  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {heroVideo ? (
        <video
          autoPlay
          muted
          loop
          playsInline
          poster={heroImage}
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
      ) : (
        <div
          className="absolute inset-0 bg-cover bg-center scale-105"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
      )}
      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
        {/* HGC Logo */}
        <img
          src="/assets/hgc-logo.png"
          alt="Hunt Global Collective"
          className="w-[420px] md:w-[560px] max-w-[85vw] h-auto"
        />
      </div>

      {/* subtle bottom scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 text-[10px] tracking-[0.3em]">
        SCROLL
      </div>
    </section>
  );
}
